import * as React from "react";

const STORAGE_KEY = "stay";

const useUserStay = () => {
  const [stay, _setStay] = React.useState();

  const setStay = (newStay) => {
    if ((!newStay?.from && !newStay?.to) || !newStay) {
      _setStay(undefined);
      window.sessionStorage.removeItem(STORAGE_KEY);
    } else {
      _setStay(newStay);
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(newStay));
    }
  };

  React.useEffect(() => {
    const storedStay = window.sessionStorage.getItem(STORAGE_KEY);
    if (storedStay) {
      setStay(JSON.parse(storedStay));
    }
  }, []);

  return [stay, setStay];
};

export default useUserStay;
